'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiTwitter1 = function (_React$Component) {
    _inherits(AiTwitter1, _React$Component);

    function AiTwitter1() {
        _classCallCheck(this, AiTwitter1);

        return _possibleConstructorReturn(this, (AiTwitter1.__proto__ || Object.getPrototypeOf(AiTwitter1)).apply(this, arguments));
    }

    _createClass(AiTwitter1, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M47.999,22.075c-1.176,0.522-2.441,0.875-3.77,1.033c1.355-0.812,2.395-2.099,2.887-3.632 c-1.27,0.753-2.676,1.299-4.17,1.593c-1.197-1.275-2.904-2.072-4.791-2.072c-3.627,0-6.566,2.938-6.566,6.564 c0,0.515,0.059,1.016,0.17,1.496c-5.455-0.273-10.295-2.887-13.531-6.859c-0.564,0.97-0.889,2.098-0.889,3.301 c0,2.277,1.158,4.287,2.92,5.464c-1.076-0.033-2.088-0.329-2.975-0.821c0,0.028,0,0.056,0,0.083c0,3.181,2.266,5.834,5.266,6.437 c-0.549,0.15-1.129,0.231-1.728,0.231c-0.424,0-0.834-0.041-1.234-0.118c0.834,2.608,3.26,4.507,6.131,4.56 c-2.246,1.761-5.074,2.809-8.152,2.809c-0.529,0-1.051-0.03-1.566-0.091c2.906,1.862,6.355,2.949,10.064,2.949 c12.076,0,18.68-10.004,18.68-18.679c0-0.285-0.006-0.568-0.019-0.85C46.007,24.548,47.12,23.392,47.999,22.075z' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '16 16 32 32';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-twitter-1', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-twitter-1', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiTwitter1;
}(_react2.default.Component);

exports.default = AiTwitter1;